core.directive('esfDuplicateFlagValidator', [
        function() {
            var definition = {
                restrict: "A",
                require: 'ngModel',
                link: function ($scope, $element, $attrs, ctrl) {
                    var validate = function (viewValue) {
                        if($attrs.esfDuplicateFlagValidator) {
                            ctrl.$setValidity('esfDuplicateFlagValidator', !JSON.parse($attrs.esfDuplicateFlagValidator));
                        }

                        return viewValue;
                    };

                    ctrl.$parsers.unshift(validate);
                    ctrl.$formatters.push(validate);

                    $attrs.$observe('esfDuplicateFlagValidator', function (comparisonValue) {
                        return validate(ctrl.$viewValue);
                    });

                }
            };

            return definition;
        }]
);